import { isMcpTool } from '@kentik/ui-shared/kaizen/constants';

const AGENT_DISPLAY_NAMES = {
  math_agent: 'Math Agent',
  synthetics_agent: 'Synthetics Agent'
};

export function getAgentDisplayName(agentName) {
  if (AGENT_DISPLAY_NAMES[agentName]) {
    return AGENT_DISPLAY_NAMES[agentName];
  }

  if (isMcpTool(agentName)) {
    return agentName
      .replace(/^mcp_/, '')
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (c) => c.toUpperCase());
  }

  return agentName.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}
